// extracted by mini-css-extract-plugin
module.exports = {"account":"Account_account__2MQHX","title":"Account_title__33qAK","topPart":"Account_topPart__DRKqL","icon":"Account_icon__8FTNx","cards":"Account_cards__3UGIr"};